import React, { useEffect, useState } from "react";
import { endpointRequest } from "../../../../../utilities/requests";
import ECLGridPlotBlock from "../../ECLGridPlotBlock/ECLGridPlotBlock";
import ECLLoader from "../../../../Widgets/ECLLoader/ECLLoader";

export default function AskChart(props) {
   const [config, setConfig] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   useEffect(() => {
      endpointRequest(
         props.parentObject ? props.parentObject : null,
         props.block ? props.block.id : null,
         props.block
            ? props.block.session
            : sessionStorage.getItem("AISession"),
         props.endpoint + "config",
      )
         .then((configuration) => {
            setConfig(JSON.parse(configuration.rows[0][0]));
            setLoading(false);
         })
         .catch((error) => {
            console.error(error);
            setError("Error loading chart configuration");
         });
   }, []);

   if (loading || error) {
      return <ECLLoader message={error} />;
   }

   return (
      <ECLGridPlotBlock
         {...props}
         plotConfigs={config.plotConfigs}
         sessionID={sessionStorage.getItem("AISession")}
      />
   );
}
